/*
 * Scroll smoothly to in-page anchors by adding
 * data-smooth-scroll attribute.
 */
$(function () {

	$('a[data-smooth-scroll]').on('click', function (e) {
		var $this = $(this),
			target = $this.data('smooth-scroll') ? $($this.data('smooth-scroll')) : $(this.hash),
			duration = $this.data('smooth-scroll-duration') || 750,
			offset = $this.data('smooth-scroll-offset') || 82;

		if (typeof(offset) == 'string') {
			offset = $(offset).outerHeight();
		}

		target = target.length ? target : $('[name=' + this.hash.replace('#', '') + ']');

		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top - offset
			}, duration, $.bez([0.4, 0, 0.2, 1]));
		}

		e.preventDefault();
		return false;
	});

});
